module.exports = __webpack_public_path__ + "static/media/pets-paw-hospital.8883aca0.svg";